// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("component-leaflet-map");

var $ = s => Array.prototype.slice.call(document.querySelectorAll(s));

var data = require("./aptbyzip.geo.json");

var mapElement = document.querySelector("leaflet-map");

if (mapElement) {
  var L = mapElement.leaflet;
  var map = mapElement.map;

  map.scrollWheelZoom.disable();

  var focused = false;


  var year = "yearAll";

  var onEachFeature = function(feature, layer) {
    // var breakdown = breakdownData[feature.properties.BEAT]
    layer.bindPopup("", {
      minWidth: 200
    });

    layer.on({
      popupopen: function(e) {
        e.popup.setContent(`
<h4>Neighborhood: ${feature.properties.city}</h4>
<b>Total apartments opening in 2016-2018: ${feature.properties.yearAll}</b><br>
<b>2016: ${feature.properties.year16}</b><br>
<b>2017: ${feature.properties.year17}</b><br>
<b>2018: ${feature.properties.year18}</b>
        `);
        layer.setStyle({ weight: 2, fillOpacity: 1 });
      },
      mouseover: function(e) {
        layer.setStyle({ weight: 2, fillOpacity: 1 });
      },
      mouseout: function(e) {
        if (focused && focused == layer) { return }
        layer.setStyle({ weight: 0.5, fillOpacity: 0.7 });
      }
    });
  };

  map.on("popupclose", function() {
    if (focused) {
      focused.setStyle({ weight: 0.5, fillOpacity: 0.7 });
      focused = false;
    }
  });

  var getColor = function(d) {
    var value = d[year];
    if (typeof value == "string") {
      value = Number(value.replace(/,/, ""));
    }
    if (typeof value != "undefined") {
      // condition ? if-true : if-false;
      return value >= 3000 ? '#800026' :
             value >= 2000 ? '#bd0026' :
             value >= 1500 ? '#e31a1c' :
             value >= 1250 ? '#fc4e2a' :
             value >= 1000 ? '#fd8d3c' :
             value >= 750 ? '#feb24c' :
             value >= 500 ? '#fed976' :
             value >= 400 ? '#ffeda0' :
             value >= 300 ? '#ffffcc' :
             value >= 200 ? '#edf8b1' :
             value >= 100 ? '#c7e9b4' :
             '#7fcdbb' ;
    } else {
      return "red"
    }
  };

  var style = function(feature) {
    var s = {
      fillColor: getColor(feature.properties),
      weight: 0.5,
      opacity: 1,
      color: 'white',
      fillOpacity: 0.5
    };
    return s;
  }

  var geojson = L.geoJson(data, {
    style: style,
    onEachFeature: onEachFeature
  }).addTo(map);

  var onTab = function() {
    if (document.querySelector(".selected")) document.querySelector(".selected").classList.remove("selected");
    this.classList.add("selected");
    year = this.getAttribute("data-year");
    geojson.setStyle(style);
    map.closePopup();
  };

  $('.tab').forEach(tab => tab.addEventListener("click", onTab));

}
